module.exports = __webpack_public_path__ + "static/media/carRide.089702b9.svg";